import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('twofactor_authentication_enabled'),
    description: defineMessage('youre_all_set_up_from_n_d_to_log_in_approvalmax'),
    button: defineMessage('done'),
};
